import axios from 'axios'
import {filter, orderBy} from "lodash";

export default {
  state: {
    currentUser: null,
    options: null,
    clients: [],
    suppliers: [],
    departments: [],
    costCategories: [],
    costs: [],
    quotes: [],
    users: [],
    usersWithKey: {},
    jobs: [],
    projects: [],
    client_managers: [],
    jobStatuses: ['pending', 'in_progress', 'testing', 'with_client', 'completed', 'invoiced'],
    taskStatuses: ['pending', 'in_progress', 'approved', 'completed', 'cancelled'],
    quoteStatuses: ['pending', 'in_progress', 'with_client', 'approved', 'completed', 'cancelled'],
    invoiceStatuses: ['pending', 'in_progress', 'approved', 'completed', 'cancelled'],
    orderStatuses: ['draft', 'pending', 'in_progress', 'approved', 'completed', 'cancelled'],
    projectStatuses: ['pending', 'in_progress', 'testing', 'with_client', 'completed', 'invoiced'],
    projectPriority: ['low', 'normal', 'high'],
    priceTiers: [{id: 'tier1', name: 'Tier 1'},{id: 'tier2', name: 'Tier 2'}],
    invoiceTerms: [{id: '0', name: 'Immediate From Invoice Date'},{id: '7', name: '7 Days From Invoice Date'},{id: '15', name: '15 Days From Invoice Date'},{id: '30', name: '30 Days From Invoice Date'},{id: '45', name: '45 Days From Invoice Date'}],
    invoiceItemTypes: [{value: 'quote', label: 'Quote'},{value: 'task', label: 'Task'},{value: 'timesheet', label: 'Time'},{value: 'order', label: 'Order'}],
    stateOpts: [{id: '1', code: 'NSW', name: 'New South Wales'},{id: '2', code: 'QLD', name: 'Queensland'},{id: '3', code: 'SA', name: 'South Australia'},{id: '4', code: 'TAS', name: 'Tasmania'},{id: '5', code: 'VIC', name: 'Victoria'},{id: '6', code: 'WA', name: 'Western Australia'},{id: '7', code: 'ACT', name: 'Australian Capital Territory'},{id: '8', code: 'NT', name: 'Northern Territory'}],
    stateWithOtherOpts: [{id: '1', code: 'NSW', name: 'New South Wales'},{id: '2', code: 'QLD', name: 'Queensland'},{id: '3', code: 'SA', name: 'South Australia'},{id: '4', code: 'TAS', name: 'Tasmania'},{id: '5', code: 'VIC', name: 'Victoria'},{id: '6', code: 'WA', name: 'Western Australia'},{id: '7', code: 'ACT', name: 'Australian Capital Territory'},{id: '8', code: 'NT', name: 'Northern Territory'},{id: '9', code: 'Other', name: 'Other'}],
    priceTierOpts: [{id: '1', code: 'tier1', name: 'Tier 1'},{id: '2', code: 'tier2', name: 'Tier 2'},{id: '3', code: 'tier3', name: 'Tier 3'},{id: '4', code: 'tier4', name: 'Tier 4'}],
    sellBasisOpts: [{code: 'quantity', name: 'Quantity'}, {code: 'time', name: 'Time'}],
    tinyApiKey: 'qb3pq4u6ghm3uu2gaib3dgn7qcb7xfrg72sagupmai6cum0q',
    tinyOpts: {height : 350},
    sequenceCharacters: 'ABCDEFGHIJKLMNOPQRSTUVXYZ',
    numberOfUnreadComments: 0,
    numberOfPendingRequests: 0,
    hideTodoItemsOptions: ['1 day', '3 days', '1 week', '2 weeks', '1 month'],
  },
  getters: {
    OPTIONS: state => state.options,
    CLIENTS: state => state.clients,
    SUPPLIERS: state => state.suppliers,
    CURRENT_USER: state => state.currentUser,
    IS_CLIENT: state => (state.currentUser && typeof state.currentUser.client_id != "undefined")?true:false,
    IS_CLIENT_MANAGER: state => (state.currentUser && typeof state.currentUser.client_id != "undefined" && parseInt(state.currentUser.is_manager))?true:false,
    IS_SUPER_ADMIN: state => (state.currentUser && typeof state.currentUser.user_type_id != "undefined" && state.currentUser.user_type_id == 1)?true:false,
    DEPARTMENTS: state => state.departments,
    COST_CATEGORIES: state => state.costCategories,
  },
  mutations: {
    SET_OPTIONS (state, item) {
      state.options = item;
    },
    SET_CLIENTS_SUPPLIERS (state, item) {
      state.clients = item ? filter(item, function(o) {
        return !o.is_supplier;
      }) : [];
      state.suppliers = item ? filter(item, function(o) {
        return o.is_supplier;
      }) : [];
    },
    SET_CURRENT_USER (state, item) {
      state.currentUser = item;
    },
    SET_USER_TYPES (state, item) {
      state.options.user_types = item;
    },
    SET_DEPARTMENTS (state, item) {
      state.departments = item
    },
    SET_COST_CATEGORIES (state, item) {
      state.costCategories = item
    },
    SET_COSTS ( state, item ) {
      state.costs = item;
    },
    SET_USERS (state, item) {
      state.users = item ? orderBy(item, ['full_name'], ['asc']) : [];
      state.usersWithKey = window.generateObjectsWithKeyFromArray(item, 'id');
    },
    SET_QUOTES (state, item) {
      state.quotes = item;
    },
    SET_JOBS (state, item) {
      state.jobs = item;
    },
    SET_PROJECTS (state, item) {
      state.projects = item;
    },
    SET_CLIENT_MANAGERS (state, item) {
      state.client_managers = item;
    },
    ADD_CLIENT (state, item) {
      state.clients.push( item )
    },
    ADD_SUPPLIER (state, item) {
      state.suppliers.push( item )
    },
    ADD_QUOTE (state, item) {
      state.quotes.push( item )
    },
    ADD_QUOTE_JOB (state, item) {
      state.jobs.push( item )
    },
    SET_NOTIFICATIONS (state, item) {
      state.numberOfUnreadComments = item.numberOfUnreadComments;
      state.numberOfPendingRequests = item.numberOfPendingRequests;
    }
  },
  actions: {
    INIT_APP: async ( context ) => {
      axios.get('/options/users')
        .then(resp => {
          context.commit('SET_USERS', resp.data.result);
        });

      let { data } = await axios.get( '/options' );
      context.commit('SET_OPTIONS', data.result);

      if ( data.result.logged_as == 'company' ) {
        axios.get('/options/clients')
          .then(resp => {
            context.commit('SET_CLIENTS_SUPPLIERS', resp.data.result);
          });

        axios.get('/options/departments')
          .then(resp => {
            context.commit('SET_DEPARTMENTS', resp.data.result);
          });

        axios.get('/options/cost-categories')
          .then(resp => {
            context.commit('SET_COST_CATEGORIES', resp.data.result);
          });

        axios.get('/options/costs')
          .then(resp => {
            context.commit('SET_COSTS', resp.data.result);
          });

        axios.get('/options/quotes')
          .then(resp => {
            context.commit('SET_QUOTES', resp.data.result);
          });

        axios.get('/options/jobs')
          .then(resp => {
            context.commit('SET_JOBS', resp.data.result);
          });

        axios.get('/options/projects')
          .then(resp => {
            context.commit('SET_PROJECTS', resp.data.result);
          });

        axios.get('/options/client_managers')
          .then(resp => {
            context.commit('SET_CLIENT_MANAGERS', resp.data.result);
          });
      }
      // else if ( data.logged_as == 'client' ) {

      // }

      let user = await axios.get( '/options/auth-user');
      context.commit('SET_CURRENT_USER', user.data.result);

      let rs = await axios.get( '/user/notifications');
      context.commit('SET_NOTIFICATIONS', rs.data.result);



      return data;
    },
    SET_CURRENT_USER ( context, user ) {
      context.commit('SET_CURRENT_USER', user);
    },
    SET_USER_TYPES ( context, userTypes ) {
      context.commit('SET_USER_TYPES', userTypes);
    },
    SET_COST_CATEGORIES ( context, data ) {
      context.commit('SET_COST_CATEGORIES', data);
    },
    SET_DEPARTMENTS ( context, data ) {
      context.commit('SET_DEPARTMENTS', data);
    },
    SET_JOBS ( context, data ) {
      context.commit('SET_JOBS', data);
    },
    SET_USERS ( context, data ) {
      context.commit('SET_USERS', data);
    },
    SET_COSTS ( context, data ) {
      context.commit('SET_COSTS', data);
    },
    GET_USERS: async ( context ) => {
      let users = await axios.get( '/options/users' )
      context.commit('SET_USERS', users.data.result);
    },
    ADD_CLIENT_SUPPLIER: async ( context, params ) => {
      let { data } = await axios.post( '/clients', params );
      if(typeof(data.result) != 'undefined')
        data = data.result;
      if (data.is_supplier)
        context.commit('ADD_SUPPLIER', data);
      else
        context.commit('ADD_CLIENT', data);
      return data;
    },
    ADD_QUOTE: async ( context, params ) => {
      let { data } = await axios.post( '/quotes', params );
      if(typeof(data.result) != 'undefined')
        data = data.result;
      context.commit('ADD_QUOTE', data);
      return data;
    },
    ADD_QUOTE_JOB: async ( context, params ) => {
      let { data } = await axios.post( '/quotes/' + params['quote_id'] + '/job', params );
      if(typeof(data.result) != 'undefined')
        data = data.result;
      context.commit('ADD_QUOTE_JOB', data);
      return data;
    },
    ADD_QUOTE_JOB_DATA: async ( context, data ) => {
      context.commit('ADD_QUOTE_JOB', data);
      return data;
    },
    GET_NOTIFICATIONS: async ( context ) => {
      let rs = await axios.get( '/user/notifications');
      context.commit('SET_NOTIFICATIONS', rs.data.result);
    }
  }
}
